module.exports = __webpack_public_path__ + "3f16e137/img/arrow-share-icon.00a12c29.svg";